// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description = "A simple module for showing sides of a debate.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Debate module",
  id: "debate-module",
  linkPrefix: "/interactives",
  tags: ["Debate", "Quote", "Configurable"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/debate-module/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import("app/components/tools/DebateModuleConfigTool/DebateModuleConfigTool"),
    loading: DynamicImportLoader,
    modules: ["DebateModuleConfigTool"]
  })
};

export default CONFIG;
